import { render, staticRenderFns } from "./SidebarSMSPanel.vue?vue&type=template&id=518c1d45&scoped=true&"
import script from "./SidebarSMSPanel.vue?vue&type=script&lang=js&"
export * from "./SidebarSMSPanel.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSMSPanel.vue?vue&type=style&index=0&id=518c1d45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518c1d45",
  null
  
)

export default component.exports